import PuxIcon from "../../PuxIcon/PuxIcon.vue";
import Spinner from "../../Spinner/Spinner.vue";

// @vue/component
export default {
  name: "TaskLogStatus",
  components: {
    PuxIcon,
    Spinner,
  },
  props: {
    status: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: undefined,
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      statusLabel: {
        PENDING: "in Warteschlange",
        STARTED: "gestartet",
        RUNNING: "in Bearbeitung",
        SUCCESS: "erfolgreich beendet",
        PARTIAL_SUCCESS: "teilweise erfolgreich beendet",
        FAILURE: "mit Fehler beendet",
      },
      statusIcon: {
        PENDING: "glyphicon-time",
        STARTED: "glyphicon-ellipsis-h",
        RUNNING: "glyphicon-ellipsis-h",
        SUCCESS: "glyphicon-ok",
        PARTIAL_SUCCESS: "glyphicon-ok",
        FAILURE: "glyphicon-close"
      },
      statusColor: {
        PENDING: "text-dark",
        STARTED: "text-dark",
        RUNNING: "text-dark",
        SUCCESS: "text-success",
        PARTIAL_SUCCESS: "text-warning",
        FAILURE: "text-danger"
      },
    };
  },
  computed: {
    isRunning() {
      return this.status === "RUNNING" || this.status === "STARTED";
    },

    showSpinner() {
      return this.animated && this.isRunning;
    },

    showIcon() {
      return !this.showSpinner;
    },

  },
};
